import axios from "axios";
import { getApiBaseUrl } from "../../config.js";

const apiPrefix = getApiBaseUrl("xmot");

export const getSurveyData = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/get-client-sessions`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteSurvey = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/remove-session`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCategoriesForXMOT = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/get-xmot-categories`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateXmotStatus = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/show-hide-xmot`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const cloneXMOTSurvey = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/clone-xmot`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const getProductListForXMOT = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/product-list`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const getProductThersholdForXMOT = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/product-thershold`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const uploadTaskImage = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/upload-task-photo`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const uploadTaskVideo = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/upload-task-video`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const getXmotSegments = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/segment-list`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const getXmptParticipantList = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/participant-list`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const saveXMOTSurvey = async (token, reqBody, stepUrl) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/${stepUrl}`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const getXmotHeaderListing = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot-header-listing`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const getTriggerDetailsDataById = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/detail-info`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const getXmotBrands = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/brand-list`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const deleteXmotTaskQuestion = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/delete-task-question`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const deleteSkipLogicTq = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/remove-skip-logic`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const deleteXmotTaskQuestionBlock = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/delete-randomization-block`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};
